"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseError_1 = require("./Errors/BaseError");
var SimpleAPIError_1 = require("./Errors/SimpleAPIError");
var SimpleAPIResponse_1 = require("./SimpleAPIResponse");
/**
 * A simple class that can parse number of Objects to try and
 * retrieve a collection of string based messages.
 */
var SimpleAPIErrorParser = /** @class */ (function () {
    function SimpleAPIErrorParser() {
    }
    /**
     * Attempts to parse various objects into an array of error messages.
     * @param {*} errorObject
     * @returns {String[]}
     */
    SimpleAPIErrorParser.parse = function (errorObject) {
        /*
         * If the object is a SimpleAPIResponse, that already
         * has the ability to parse itself for errors.
         */
        if (errorObject instanceof SimpleAPIResponse_1.SimpleAPIResponse) {
            if (errorObject.isError()) {
                return errorObject.getErrors(true);
            }
            else {
                return null;
            }
            /*
             * If its a single SimpleAPI error return an array of that.
             */
        }
        else if (errorObject instanceof SimpleAPIError_1.SimpleAPIError) {
            return [errorObject.getMessage()];
            /*
             * If the object is a Base Error, Parse that.
             */
        }
        else if (errorObject instanceof BaseError_1.BaseError) {
            return [errorObject.getMessage()];
            /*
             * If its just a string, return that
             */
        }
        else if (typeof errorObject === "string") {
            return [errorObject];
            /*
             * If its a javascript Error, then return that
             */
        }
        else if (errorObject instanceof Error) {
            return [errorObject.message];
            /*
             * Otherwise we have no idea what it is and return the object.
             */
        }
        else {
            return [errorObject];
        }
    };
    return SimpleAPIErrorParser;
}());
exports.SimpleAPIErrorParser = SimpleAPIErrorParser;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2ltcGxlQVBJRXJyb3JQYXJzZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvQVBJL1NpbXBsZUFQSS9TaW1wbGVBUElFcnJvclBhcnNlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLGdEQUErQztBQUMvQywwREFBeUQ7QUFDekQseURBQXdEO0FBRXhEOzs7R0FHRztBQUNIO0lBQUE7SUFpREEsQ0FBQztJQWhEQzs7OztPQUlHO0lBQ1csMEJBQUssR0FBbkIsVUFBb0IsV0FBVztRQUM3Qjs7O1dBR0c7UUFDSCxJQUFJLFdBQVcsWUFBWSxxQ0FBaUIsRUFBRTtZQUM1QyxJQUFJLFdBQVcsQ0FBQyxPQUFPLEVBQUUsRUFBRTtnQkFDekIsT0FBTyxXQUFXLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBYSxDQUFDO2FBQ2hEO2lCQUFNO2dCQUNMLE9BQU8sSUFBSSxDQUFDO2FBQ2I7WUFFRDs7ZUFFRztTQUNKO2FBQU0sSUFBSSxXQUFXLFlBQVksK0JBQWMsRUFBRTtZQUNoRCxPQUFPLENBQUMsV0FBVyxDQUFDLFVBQVUsRUFBRSxDQUFDLENBQUM7WUFFbEM7O2VBRUc7U0FDSjthQUFNLElBQUksV0FBVyxZQUFZLHFCQUFTLEVBQUU7WUFDM0MsT0FBTyxDQUFDLFdBQVcsQ0FBQyxVQUFVLEVBQUUsQ0FBQyxDQUFDO1lBRWxDOztlQUVHO1NBQ0o7YUFBTSxJQUFJLE9BQU8sV0FBVyxLQUFLLFFBQVEsRUFBRTtZQUMxQyxPQUFPLENBQUMsV0FBVyxDQUFDLENBQUM7WUFFckI7O2VBRUc7U0FDSjthQUFNLElBQUksV0FBVyxZQUFZLEtBQUssRUFBRTtZQUN2QyxPQUFPLENBQUMsV0FBVyxDQUFDLE9BQU8sQ0FBQyxDQUFDO1lBRTdCOztlQUVHO1NBQ0o7YUFBTTtZQUNMLE9BQU8sQ0FBQyxXQUFXLENBQUMsQ0FBQztTQUN0QjtJQUNILENBQUM7SUFDSCwyQkFBQztBQUFELENBQUMsQUFqREQsSUFpREM7QUFqRFksb0RBQW9CIn0=